import { REQUEST_ATTEMPT_DEFAULT as Ae } from "../common/constants.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
var h = {
  H: {
    Tu: "data",
    bi: "content_cards/sync",
    $e: "feature_flags/sync",
    Ir: "template",
    G: "banners/sync"
  },
  Yu: function Yu(t) {
    return null == t ? void 0 : t.lt(s.ct.SE);
  },
  sm: function sm(t) {
    return null == t ? void 0 : t.lt(s.ct._E);
  },
  nm: function nm(t, e) {
    null == t || t.ft(s.ct.SE, e);
  },
  rm: function rm(t, e) {
    null == t || t.ft(s.ct._E, e);
  },
  Cu: function Cu(t, e) {
    if (!t || !e) return -1;
    var s = h.Yu(t);
    if (null == s) return -1;
    var n = s[e];
    return null == n || isNaN(n) ? -1 : n;
  },
  Su: function Su(t, e) {
    var s = Ae;
    if (!t || !e) return s;
    var n = h.sm(t);
    return null == n ? s : (s = n[e], null == s || isNaN(s) ? Ae : s);
  },
  K: function K(t, e, s) {
    if (!t || !e) return;
    var n = h.Yu(t);
    null == n && (n = {}), n[e] = s, h.nm(t, n);
  },
  Bu: function Bu(t, e, s) {
    if (!t || !e) return;
    var n = h.sm(t);
    null == n && (n = {}), n[e] = s, h.rm(t, n);
  },
  Ci: function Ci(t, e) {
    t && e && h.Bu(t, e, Ae);
  },
  Ku: function Ku(t, e) {
    if (!t || !e) return;
    var s = h.Su(t, e);
    h.Bu(t, e, s + 1);
  }
};
export default h;